import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnvelope = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.5 2.5H2.5C1.80964 2.5 1.25 3.05964 1.25 3.75V11.25C1.25 11.9404 1.80964 12.5 2.5 12.5H12.5C13.1904 12.5 13.75 11.9404 13.75 11.25V3.75C13.75 3.05964 13.1904 2.5 12.5 2.5Z",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.75 4.375L7.5 7.5L1.25 4.375",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEnvelope;
